module.exports = __webpack_public_path__ + "img/953688e.png";